import { type ProductListResultViewModel, FilterViewModelDiscriminator } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import React, { memo } from 'react';
import { hideOnMobile } from 'components/pages/Checkout/components/Delivery/shared/styles';
import LinkFilter from './components/LinkFilter/LinkFilter';

const SidebarFilters = ({ model: filters }: { model: ProductListResultViewModel['filters'] }) => {
    const filtersForSidebar = filters.filter((filter) => filter.attribute.location === 'Left');

    return (
        <Flex.Column css={hideOnMobile}>
            {filtersForSidebar.map((filter) =>
                FilterViewModelDiscriminator(
                    filter,
                    () => null, // Price filter not supported in sidebar
                    () => null, // Brand filter not supported in sidebar
                    () => null, // Bool filter not supported in sidebar
                    () => null, // BoolStar filter not supported in sidebar
                    () => null, // Range filter not supported in sidebar
                    () => null, // Color filter not supported in sidebar
                    (linkModel) => <LinkFilter key={filter.displayName} model={linkModel} />,
                    () => null
                )
            )}
        </Flex.Column>
    );
};

export default memo(SidebarFilters);
